import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d3e8412"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "patient-details d-flex flex-col mha-font-body-sm" }
const _hoisted_2 = { class: "d-flex flex-row" }
const _hoisted_3 = { class: "row-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-color-neutral-dark-grey" }, "Health Insurance Number", -1))
const _hoisted_5 = { class: "value m-t-16" }
const _hoisted_6 = { class: "row-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-color-neutral-dark-grey" }, "Healthcare Province", -1))
const _hoisted_8 = { class: "value m-t-16" }
const _hoisted_9 = { class: "d-flex flex-row m-t-32" }
const _hoisted_10 = { class: "row-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-color-neutral-dark-grey" }, "Sex", -1))
const _hoisted_12 = { class: "value m-t-16" }
const _hoisted_13 = { class: "row-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-color-neutral-dark-grey" }, "Date Of Birth", -1))
const _hoisted_15 = { class: "value m-t-16" }
const _hoisted_16 = { class: "d-flex flex-row m-t-32" }
const _hoisted_17 = { class: "row-item" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-color-neutral-dark-grey" }, "Guardian Email", -1))
const _hoisted_20 = ["title"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-color-neutral-dark-grey" }, "Patient Email", -1))
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "row-item" }
const _hoisted_25 = {
  key: 0,
  class: "font-color-neutral-dark-grey"
}
const _hoisted_26 = {
  key: 1,
  class: "font-color-neutral-dark-grey"
}
const _hoisted_27 = ["title"]
const _hoisted_28 = {
  key: 0,
  class: "d-flex flex-row m-t-32"
}
const _hoisted_29 = { class: "row-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-color-neutral-dark-grey" }, "Guardian Name", -1))
const _hoisted_31 = { class: "value m-t-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.healthNumberWithVersion), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.remotePatient.health_care_province_code), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.patientSex), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.patientBirthDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        (_ctx.isDependent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", {
                class: "value m-t-16",
                title: _ctx.patient.guardian.email
              }, _toDisplayString(_ctx.patient.guardian.email), 9, _hoisted_20)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", {
                class: "value m-t-16",
                title: _ctx.remotePatient.email
              }, _toDisplayString(_ctx.remotePatient.email), 9, _hoisted_23)
            ]))
      ]),
      _createElementVNode("div", _hoisted_24, [
        (_ctx.isDependent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Guardian Phone Number"))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, "Phone Number")),
        _createElementVNode("div", {
          class: "value m-t-16",
          title: _ctx.patientPhoneNumber
        }, _toDisplayString(_ctx.patientPhoneNumber), 9, _hoisted_27)
      ])
    ]),
    (_ctx.isDependent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.guardianDisplayName), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}